import styles from "./InputField.module.scss";

const DateField = ({
  type = "date",
  name,
  label,
  register,
  validation = {},
  errors,
  required = false,
  placeholder = "",
  isStatic = false,
  readOnly = false,
  onChange = () => {},
  onBlur = () => {},
  watch = null,
}) => {
  // invald Date判定
  const isInvalidDate = (date) => Number.isNaN(date.getDate());

  const inputMax = () => {
    if (type === "date") {
      return "9999-12-31";
    } else if (type === "datetime-local") {
      return "9999-12-31T23:59";
    } else {
      return null;
    }
  };

  const returnDateText = () => {
    let returnVal = "";
    if (isStatic) {
      // 入力欄の値取得
      const val = watch(name);
      const dVal = new Date(watch(name));
      if (val && !isInvalidDate(dVal)) {
        let y = dVal.getFullYear();
        let m = dVal.getMonth() + 1;
        let d = dVal.getDate();
        returnVal = y + "年" + m + "月" + d + "日";
      }
    }
    return returnVal;
  };

  return (
    <div className={styles.field} hidden={type === "hidden"}>
      <label className={`form-label ${styles.field__label}`}>
        {label}
        <span className={styles.field__label__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </label>

      <input
        className={`${styles.field__input} ${
          errors[name] ? "is-invalid" : ""
        } ${isStatic ? "d-none" : "form-control"}`}
        type={type}
        placeholder={isStatic ? "" : placeholder}
        {...register(name, {
          ...validation,
          onChange: onChange,
          onBlur: onBlur,
        })}
        readOnly={isStatic || readOnly}
        max={inputMax()}
      />
      {isStatic ? (
        <div className={`${styles.staticlabel} form-control-plaintext`}>
          {returnDateText()}
        </div>
      ) : (
        <></>
      )}
      <p className={`invalid-feedback ${styles.field__msg}`}>
        {errors[name] ? errors[name].message : ""}
      </p>
    </div>
  );
};

export default DateField;
